import { Citrus } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="bg-brand-green text-brand-cream py-5 overflow-hidden border-y-2 border-brand-green" data-testid="marquee-divider">
      <div className="animate-marquee w-max flex items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-display text-3xl md:text-5xl uppercase tracking-tight">
            <span>{item}</span>
            <Citrus className="w-7 h-7 md:w-9 md:h-9 text-brand-orange shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
